import React, {FC} from 'react';

import {useLoadReport} from '../../pages/ReportPage/hooks';
import {makeReportViewInfoSelector} from '../../pages/ReportPage/selectors';
import {usePropsSelector} from '../../state/hooks';
import {
  ShareReportModalHeaderAction,
  ShareReportTrigger,
} from '../ShareReportTrigger';

interface ShareReportTriggerWrapperProps {
  reportID: string;
  reportName: string;
  userIsMemberOfTeam?: boolean;
  unsetReportID?: () => void;
}

export const ShareReportTriggerWrapper: FC<ShareReportTriggerWrapperProps> = ({
  reportID,
  reportName,
  unsetReportID,
  userIsMemberOfTeam,
}) => {
  // Retrieve relevant data from redux
  useLoadReport(reportID);
  const {reportViewRef, view} = usePropsSelector(makeReportViewInfoSelector);

  if (!reportViewRef || view == null) {
    return null;
  }

  return (
    <ShareReportTrigger
      isModalInitiallyOpen={true}
      onModalClose={unsetReportID}
      modalHeaderAction={
        ShareReportModalHeaderAction.EDIT_REPORT_BEFORE_SHARING
      }
      modalTitle={`Share "${reportName}"`}
      viewRef={reportViewRef}
      view={view}
      isSharePanel={true}
      userIsMemberOfTeam={userIsMemberOfTeam}
    />
  );
};
